"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSingleFieldConcentrationLimitKickouts = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./selectFunctions/utils");
const standard_1 = require("./standard");
const isValidGroupByFieldValue = ({ groupingFieldType, fieldValue, }) => {
    switch (groupingFieldType) {
        case 'string':
            return typeof fieldValue === 'string';
        case 'integer':
            return typeof fieldValue === 'number' && Number.isInteger(fieldValue);
        default:
            return (0, common_1.finleyAssertUnreachable)(groupingFieldType);
    }
};
/**
 * Calculates concentration and kickouts by grouping the receivables by a single field.
 * This can be used where we want to limit concentration for of each customer or each industry.
 */
const calculateSingleFieldConcentrationLimitKickouts = ({ groupingField, groupingFieldType, concentrationReceivables, totalConcentrationExposure, concentrationLimit, concentrationLimitValueType, }) => {
    // group receivables by the grouping field value.
    const grouped = lodash_1.default.groupBy(concentrationReceivables, (rec) => {
        const fieldValue = (0, utils_1.getFieldValue)({
            loanTape: rec,
            field: groupingField,
        });
        (0, common_1.finleyAssert)(isValidGroupByFieldValue({
            groupingFieldType,
            fieldValue,
        }), `Invalid value type for [field:${groupingField}]. [Expected type:${groupingFieldType}] but found [value:${fieldValue}], [type: ${typeof fieldValue}]`);
        return fieldValue;
    });
    const standardBorrowingBaseReductions = lodash_1.default.values(grouped).map((receivables) => {
        return (0, standard_1.calculateStandardConcentrationLimitKickouts)({
            concentrationLimit,
            totalConcentrationExposure,
            concentrationReceivables: receivables,
            concentrationLimitValueType,
        });
    });
    let concentrationAmount = 0;
    // each group will have different concentration,
    // let us report max concentration among groups as `concentration`
    let concentration = 0;
    const concentrationKickouts = standardBorrowingBaseReductions.reduce((result, { calculations, kickouts }) => {
        const pairs = lodash_1.default.toPairs(kickouts);
        pairs.forEach(([finleyReceivableId, kickout]) => {
            if (kickout === 0)
                return true;
            if (!result[finleyReceivableId]) {
                // eslint-disable-next-line no-param-reassign
                result[finleyReceivableId] = 0;
            }
            // eslint-disable-next-line no-param-reassign
            result[finleyReceivableId] += kickout;
            return true;
        });
        if (calculations.concentration > concentration) {
            concentration = calculations.concentration;
            concentrationAmount = calculations.concentrationAmount || 0;
        }
        return result;
    }, {});
    return {
        kickouts: concentrationKickouts,
        calculations: {
            concentrationAmount,
            concentrationLimit: standardBorrowingBaseReductions.length > 0
                ? standardBorrowingBaseReductions[0].calculations.concentrationLimit
                : 0,
            concentration,
        },
    };
};
exports.calculateSingleFieldConcentrationLimitKickouts = calculateSingleFieldConcentrationLimitKickouts;
//# sourceMappingURL=groupBySingleField.js.map